import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { loginEduLegacyDefaultDataSchema } from './data';

/**
 * Default-placement legacy login-edu envelope.
 *
 * `type` is `z.literal('default').optional()` so that persisted entities
 * written before the discriminator existed (which omit `type` entirely) parse
 * here, and the zod discriminated union in `./entity.ts` falls through to this
 * branch when the field is missing.
 *
 * The host model registers `params.type: ['default', 'specific', 'zero']`;
 * `'specific'` shares this envelope — it only changes editor chrome, never the
 * persisted shape (the image widget's precedent).
 */
export const loginEduLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('login-edu'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('default').optional(),
    data: loginEduLegacyDefaultDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
